/* eslint-disable react/destructuring-assignment -- Will make the code unnecessarily complex */
import { AudioPlayerSkeleton } from "@circle-react-shared/MediaPlayer/AudioPlayer/AudioPlayerSkeleton";
import { isAudioContentType } from "@circle-react-shared/MediaPlayer/mediaType";
import { useMediaConfig } from "@circle-react-shared/MediaPlayer/VideoPlayer/hooks/useMediaConfig";
import { VideoPlayerSkeleton } from "@circle-react-shared/MediaPlayer/VideoPlayer/VideoPlayerSkeleton";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense } from "react";

import type { TranscriptsPlayerProps } from "@/react/components/shared/uikit/TranscriptsPlayer/types";

const AudioPlayer = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "MediaChromeAudioPlayer" */ "@circle-react-shared/MediaPlayer/AudioPlayer"
  ).then(module => ({ default: module.AudioPlayer })),
);

const VideoPlayer = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "MediaChromeVideoPlayer" */ "@circle-react-shared/MediaPlayer/VideoPlayer"
  ).then(module => ({ default: module.VideoPlayer })),
);

export const TranscriptsPlayerWrapper = (props: TranscriptsPlayerProps) => {
  const isAudioFile = isAudioContentType(props.type);
  const { posterUrl, isDownloadable, mediaTranscriptId } = useMediaConfig({
    signedId: props.signedId,
    posterUrl: props.poster,
    isDownloadable: props.isDownloadable,
    mediaTranscriptId: props.mediaTranscriptId,
  });

  if (isAudioFile)
    return (
      <Suspense fallback={<AudioPlayerSkeleton />}>
        <AudioPlayer
          downloadable={props.isDownloadable}
          downloadUrl={props.downloadUrl}
          mediaTranscriptId={props.mediaTranscriptId}
          src={props.src}
          chaptersUrl={props.chaptersUrl}
          onProgress={props.onProgress}
          overlayActions={props.overlayActions}
          posterUrl={props.poster}
          preload={props.preload}
          signedId={props.signedId}
          title={props.title}
          customizeMediaOverlayTooltipProps={
            props.customizeMediaOverlayTooltipProps
          }
        />
      </Suspense>
    );

  return (
    <Suspense
      fallback={
        <VideoPlayerSkeleton
          aspectRatio={props.aspectRatio}
          posterUrl={posterUrl}
        />
      }
    >
      <VideoPlayer
        src={props.src}
        contentType={props.type}
        mediaTranscoding={props.mediaTranscoding}
        mediaTranscriptId={mediaTranscriptId}
        overlayActions={props.overlayActions}
        downloadable={isDownloadable}
        downloadUrl={props.downloadUrl}
        lockAspectRatio={props.lockAspectRatio}
        maxHeight={props.maxHeight}
        posterUrl={posterUrl}
        chaptersUrl={props.chaptersUrl}
        previewThumbnailsUrl={props.previewThumbnailsUrl}
        signedId={props.signedId}
        variants={props.variants}
        onProgress={props.onProgress}
        preload={props.preload}
        customizeMediaOverlayTooltipProps={
          props.customizeMediaOverlayTooltipProps
        }
        transcriptContainerClassName={props.transcriptContainerClassName}
      />
    </Suspense>
  );
};
